<template>
  <div :class="$style.base">
    <div :class="$style.wrap">
      <div :class="$style.inner">
        <svg viewBox="0 0 24 24" fill="none" :class="$style.svg">
          <g>
            <path
              fill="#393939"
              fill-opacity=".5"
              d="M13.41 12l4.3-4.29a1 1 0 10-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 00-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 000 1.42 1 1 0 001.42 0l4.29-4.3 4.29 4.3a1 1 0 001.42 0 1 1 0 000-1.42z"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>

.base {
  display: inline-block;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}

.wrap {
  .base.clickable & {
    width: calc(100% + 8px);
    height: calc(100% + 8px);
    margin: -4px;
    padding: 4px;
  }
}

.inner {
  position: relative;
  padding-bottom: 100%;
}

.svg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
